<div class="page-wrapper">
  <div class="fp-container">

    <!-- Header -->
    <div class="login-header">
      <img src="/assets/healthpicks-operator/images/logo.svg" alt="Health Picks" class="logo-img" />
      <h1 class="screen-title">運用者画面</h1>
    </div>

    <!-- Card -->
    <div class="fp-card">
      
        
      <div class="fp-header-group">
        <!-- Card header: back arrow + title -->
        <div class="fp-card-header">
          <button class="back-btn" type="button" (click)="navigate('login')" aria-label="ログインに戻る">
            <img
              src="/assets/healthpicks-operator/images/back-arrow.svg"
              alt=""
              width="32"
              height="32"
            />
          </button>
          <h2 class="fp-card-title">パスワードの再設定</h2>
          <div class="fp-spacer"></div>
        </div>

        <!-- Description -->
        <div class="fp-description">
          <p>下記に登録したメールアドレスを入力してください。</p>
          <p>パスワード再設定のご案内をメールでお送りします。</p>
        </div>
      </div>



      <form (ngSubmit)="changePassword()" class="fp-form">
        <!-- Email -->
        <div class="field-group">
          <div class="field-label">
            <label for="email">メールアドレス</label>
          </div>
          <div class="field-input-stack">
            <input
              type="email"
              id="email"
              [(ngModel)]="email"
              name="email"
              placeholder="メールアドレス"
              autocomplete="email"
              [class.input-error]="errorMessages.forgetpassword.email"
              class="form-input"
            />
            <app-healthpicks-operator-field-error [message]="errorMessages.forgetpassword.email"></app-healthpicks-operator-field-error>
          </div>
        </div>

        <!-- Submit -->
        <div class="fp-footer">
          <button
            type="submit"
            class="btn-primary"
            [class.btn-disabled]="!email"
            [disabled]="!email"
          >
            送信
          </button>
        </div>
      </form>

    </div>

  </div>
</div>
